var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('svg', {
    attrs: {
      "height": "512pt",
      "viewBox": "0 0 512.0015 512",
      "width": "512pt",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "m456.882812 0h-194.308593c-3.976563 0-7.792969 1.582031-10.605469 4.394531l-235.855469 235.847657c-21.484375 21.492187-21.484375 56.457031 0 77.941406l177.699219 177.695312c10.375 10.375 24.214844 16.089844 38.964844 16.09375h.003906c14.753906 0 28.59375-5.71875 38.972656-16.097656l235.847656-235.851562c2.8125-2.8125 4.394532-6.628907 4.394532-10.605469l.003906-194.308594c-.003906-30.386719-24.730469-55.109375-55.117188-55.109375zm25.113282 243.207031-231.457032 231.457031c-4.710937 4.714844-11.019531 7.308594-17.757812 7.308594-6.742188 0-13.046875-2.59375-17.757812-7.304687l-177.699219-177.695313c-9.789063-9.789062-9.789063-25.726562 0-35.519531l231.460937-231.453125h188.097656c13.847657 0 25.117188 11.265625 25.117188 25.113281zm0 0"
    }
  }), _c('path', {
    attrs: {
      "d": "m379.785156 85.078125c-12.589844 0-24.425781 4.90625-33.328125 13.808594-8.902343 8.898437-13.804687 20.734375-13.804687 33.324219 0 12.589843 4.902344 24.425781 13.804687 33.328124 8.902344 8.902344 20.738281 13.804688 33.328125 13.804688 12.585938 0 24.421875-4.902344 33.324219-13.804688 8.902344-8.902343 13.804687-20.738281 13.804687-33.328124 0-12.589844-4.902343-24.425782-13.800781-33.324219-8.902343-8.902344-20.738281-13.808594-33.328125-13.808594zm12.113282 59.246094c-3.234376 3.238281-7.539063 5.019531-12.113282 5.019531-4.578125 0-8.878906-1.78125-12.113281-5.019531-3.238281-3.234375-5.019531-7.539063-5.019531-12.113281 0-4.574219 1.78125-8.878907 5.019531-12.113282 3.234375-3.238281 7.539063-5.019531 12.113281-5.019531 4.574219 0 8.875 1.78125 12.113282 5.019531 3.238281 3.234375 5.019531 7.539063 5.019531 12.113282 0 4.574218-1.785157 8.878906-5.019531 12.113281zm0 0"
    }
  })]);

}
var staticRenderFns = []

export { render, staticRenderFns }